<template>
  <div class="container">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">Test Field Text</th>
          <th scope="col">Test Area Text</th>
        </tr>
      </thead>
      <tbody>
        <tr class="clickable-row" v-for="(submission, index) in mySubmissions" :key="index">
          <td>
            <a v-bind:href="submission.url">{{submission.text1}}</a>
          </td>
          <td>{{submission.text2}}</td>
        </tr>
      </tbody>
    </table>
    <button class="btn btn-primary" @click="dashboardRedirect">Dashboard</button>
  </div>
</template>

<script>
import { FORMIO_ENDPOINT } from "@/api/formioApi";
import { mapState } from "vuex";
import { Form } from "vue-formio";
import { Formio } from "formiojs";

export default {
  data() {
    return {
      mySubmissions: []
    };
  },
  components: {
    formio: Form
  },
  mounted() {
    this.getSubmissions();
  },
  computed: {
    demoformio() {
      return `${FORMIO_ENDPOINT}/demo`;
    },
    ...mapState("user", ["user"])
  },
  methods: {
    getSubmissions() {
      var formio = new Formio(this.demoformio);
      formio
        .loadSubmissions({ params: { owner: this.user._id } })
        .then(submissions => {
          submissions.forEach(submission => {
            var subm = {};
            subm["_id"] = submission._id;
            subm["url"] = "/submissions/" + submission._id;
            subm["text1"] = submission.data.textTest;
            subm["text2"] = submission.data.textTest2;
            this.mySubmissions.push(subm);
          });
        });
    },
    dashboardRedirect: function() {
      this.$router.push({ name: "dashboard" });
    }
  }
};
</script>